import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { connect } from "react-redux";
import ParameterKnob from 'components/knobs/ParameterKnob.js';
import { Circle, Group, Stage, FastLayer, Layer, Rect, Line} from 'react-konva';
import WetSlider from './WetSlider.js';
import EffectParameterSlider from './EffectParameterSlider.js';
import Dropdown from 'react-dropdown';
import EQCurve from './EQCurve.js';
import SpectrumPoints from './SpectrumPoints.js';
import EqualizerPointInfo from './EqualizerPointInfo.js';
import {getLogScale} from './SpectrumUtils.js';
import EQ8UpdateRateDropdown from './EQ8UpdateRateDropdown.js';

const HEIGHT=160;
const WIDTH=360;
const WIDTH_CACHE = {};
window.WIDTH_CACHE = WIDTH_CACHE;

class FrequencyAnalyserEffect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            effect: props.effect,
            pts: [],
            frequency: 0,
            selectedPoint: props.effect.equalizerPoints[0],
        };

    }

    shouldComponentUpdate(nextProps, nextState) {
        this.state.effect = nextProps.effect;
        return true;
    }

    handleOptionChange(evt) {
        this.setState(this.state);
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.state.effect.isEnabled();
    }

    onChangeSynced(synced) {
        document.activeElement.blur();
        this.setState(this.state);
    }

    getWidth(i) {
        if (WIDTH_CACHE[i] !== undefined) {
            return WIDTH_CACHE[i];
        }

        let width = undefined;
        if (i < 5) {
            width = getLogScale(256-i, 252, 256, 10, 20);
        } else if (i < 12) {
            width = getLogScale(256-i, 245, 252, 4, 10);
        } else if (i < 16) { 
            width = getLogScale(256-i, 241, 245, 2, 4);
        } else {
            width = getLogScale(256-i, 0, 241, 1, 2);
        }

        WIDTH_CACHE[i] = width;
        return width;
    }

    setSelectedPoint(pt) {
        this.setState({selectedPoint: pt});
    }

    onClickEqualizerPoint(eq) {
        if (this.state.selectedPoint === eq) {
            eq.enabled = false;
            let newSelected = undefined;
            for (let i in this.state.effect.equalizerPoints) {
                let pt = this.state.effect.equalizerPoints[i];
                if (pt.enabled) {
                    newSelected = pt;
                    break;
                }
            }

            this.setState({selectedPoint: newSelected});
            return;
        }

        if (!eq.enabled) {
            eq.enabled = true;
        }
        this.setState({selectedPoint: eq});
    }

    onUpdateRateChanged(x) {
        this.state.effect.updateRate = x;
        this.setState(this.state);
    }

    render() {
        let className = this.props.automation !== undefined ?
            'enabled effect effect-automation' :
            'effect disabled';
        return (
            <div>
              {!this.isEnabled() ? '' :
                <div>
                  <div className="eq8">
                    <div className="eq8-knobs">
                      <ParameterKnob
                        color="#f55442"
                        scrollContainer={this.props.scrollContainer}
                        name='Freq'
                        unit="Hz"
                        parameter={this.state.selectedPoint.frequencyParameter}
                      />
                      <ParameterKnob
                        color="#f55442"
                        scrollContainer={this.props.scrollContainer}
                        unit='db'
                        name='Gain'
                        parameter={this.state.selectedPoint.gainParameter}
                      />
                      <ParameterKnob
                        color="#f55442"
                        scrollContainer={this.props.scrollContainer}
                        name='Q'
                        min={0.1}
                        parameter={this.state.selectedPoint.qParameter}
                      />
                    </div>
                    <div>
                    <div className="spectrum-container">
                      <Stage
                        width={WIDTH} height={HEIGHT}>
               <Provider store={this.props.sequencerEngine.store}>
                        <FastLayer
                          width={WIDTH} height={HEIGHT}>
                          <Rect width={WIDTH} height={HEIGHT} fill="black"/>
                          <SpectrumPoints
                            updateRate={this.state.effect.updateRate}
                            sequencerEngine={this.props.sequencerEngine}
                            getWidth={(x) => this.getWidth(x)}
                            effect={this.state.effect}/>
                        </FastLayer>
                    <Layer width={WIDTH} height={HEIGHT}>
                      <EQCurve
                        selectedPoint={this.state.selectedPoint}
                        setSelectedPoint={(pt) => this.setSelectedPoint(pt)}
                        effect={this.props.effect}
                        getWidth={(x) => this.getWidth(x)}
                        setDraggingPoint={(pt) => this.setState({draggingPoint: pt})}/>
                    </Layer>
               </Provider>
                  </Stage>
                </div> 
                  <div className="equalizer-parameters">
                    <div className="equalizer-points">
                      {this.state.effect.equalizerPoints.map(
                          eq =>
                              <EqualizerPointInfo
                                onClick={() => this.onClickEqualizerPoint(eq)}
                                selected={this.state.selectedPoint === eq}
                                equalizerPoint={eq}/>)}
                      <div className="eq8-update-rate-dropdown-container">
                        <EQ8UpdateRateDropdown
                          updateRate={this.state.effect.updateRate}
                          onUpdateRateChanged={(x) => this.onUpdateRateChanged(x)}/>
                      </div>
                    </div>
               </div>
                  </div>
                  </div>
                </div>
              }
              
            </div>
        );
    }
}

export default FrequencyAnalyserEffect;
